module.exports = __webpack_public_path__ + "assets/img/26_894.be329470.jpg";